import { render, staticRenderFns } from "./contactName.vue?vue&type=template&id=1f586382&scoped=true"
import script from "./contactName.vue?vue&type=script&lang=js"
export * from "./contactName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f586382",
  null
  
)

export default component.exports